<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Edit Kang Teknisi</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama</label>
                                                <input type="text" class="form-control" placeholder="Nama Admin..." v-model="nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Telepon <span class="text-info">( Cth : 6281336xxx )</span></label>
                                                <input type="number" class="form-control" placeholder="Telepon..." v-model="telepon">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Sebagai ?</label>
												<select class="form-control" id="tarif" v-model="teknisi" >
													<option disabled value="" selected>Pilih Sebagai</option>
													<option value="ya">Kepala Teknisi</option>
													<option value="yb" >Teknisi</option>
												</select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Username <small>(Untuk login di aplikasi juga)</small>	</label>
                                                <input type="text" class="form-control" placeholder="Username..." v-model="username">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Password <small>{Untuk login di aplikasi juga}</small></label>
                                                <input type="text" class="form-control" placeholder="Password..." v-model="password">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="Simpan">Simpan</button>
										<div class="alert alert-info" role="alert" v-show="alert">
											{{alertText}}
										</div>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { url } from '@/var/var.js'
import inter from '@/globalFunc/Interface' 
import router from '@/router'

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			id: '',
			nama: '',
			telepon: '',
			teknisi: '',
			username: '',
			password: '',

			alert: false,
			alertText: "",
		}
	},
	methods: {
        Simpan() {
			if (this.nama == "") {
				this.alert = true;
				this.alertText = "Nama tidak boleh kosong";
				return false;
			}

			if (this.telepon == "") {
				this.alert = true;
				this.alertText = "Telepon tidak boleh kosong";
				return false;
			}

			var regExp = /[a-zA-Z]/g;
			if (regExp.test(this.telepon)) {
				this.alert = true;
				this.alertText = "Telepon tidak boleh ada huruf";
				return false;
			}

			if (this.teknisi == "") {
				this.alert = true;
				this.alertText = "Sebagai tidak boleh kosong";
				return false;
			}

			if (this.username == "") {
				this.alert = true;
				this.alertText = "Username tidak boleh kosong";
				return false;
			}

			if (this.password == "") {
				this.alert = true;
				this.alertText = "Password tidak boleh kosong";
				return false;
			}

			this.alert = false;

			var datax = {
				token: 'TangTung '+sessionStorage.getItem('myToken'),
				id: this.id,
				nama: this.nama,
				telepon: this.telepon,
				teknisi: this.teknisi,
				username: this.username,
				password: this.password,
				update: 'ya'
			}
            var apiUrl = inter.AdminTambahTeknisi();
            
			this.PostData(datax,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
				    this.alert = false;
					router.push({ 
						name: 'admin-teknisi'
						/*
						params: {
							data: pax
						} 
						*/
					});
				} else {
				    this.alert = true;
				    this.alertText = x.pesan;
				}
			})
        }
	},
	mounted() {
        document.title = "Edit Kang Teknisi";

        //this.data.params = this.$route.params;

        console.log(JSON.stringify(this.$route.params.data));

        let data = this.$route.params.data;

        this.id = data.id;
        this.nama = data.nama;
        this.telepon = data.telepon;
        this.teknisi = data.teknisi;
        this.username = data.pin;
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
.modal {
	display: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/teknisi/edit.vue